// @ts-nocheck
import React, {useState} from 'react'
import {  Typography, Box, Card, CardContent, CardActions, Button } from '@mui/material';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  TimeScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  ChartType
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';

import { isPopulated} from '../AvailableSkids/skidsHelpers';
import { BuildChartAxis, type AxisOptions} from './chartHelpers';


export interface ChartProps{
    data:Map<string, {timestamp:number, value:number}[]>,
    options?:ChartOptions,
}

export interface ChartOptions{
    horizontal?:boolean,
    title?:string,
    showStats?:boolean,
    splitYAxis?:boolean,
    leftYAxis?:string[],
    rightYAxis?:string[],
}
  ChartJS.register(
        LineElement,
        PointElement,
        LinearScale,
        TimeScale,
        Title,
        Tooltip,
        Legend,
        CategoryScale
    );
function datasetFromData(data:Map<string, {timestamp:number, value:number}[]>):any[]{
    const colors = ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(75, 192, 192)', 'rgb(255, 206, 86)', 'rgb(153, 102, 255)', 'rgb(255, 159, 64)']
    let counter = 0
    const datasets:any[] = []
    data.forEach((value, key)=>{
        const dataset = {
            label: key,
            data: value.map(v=>({x:v.timestamp, y:v.value})),
            borderColor: colors[counter % colors.length],
            backgroundColor: colors[counter % colors.length],
            tension: 0.3
            
        }
        counter++
        datasets.push(dataset)
    })
    console.log('datasets:',datasets)
    return datasets
}
function buildChartData(data:Map<string, {timestamp:number, value:number}[]>):any{
    const chartData = {
  datasets: datasetFromData(data),
};
return chartData
}
 const rawData = [
    { ts: 1693708800, value: 10 }, // 2023-09-03
    { ts: 1693795200, value: 15 },
    { ts: 1693881600, value: 8 },
    { ts: 1693968000, value: 20 }
  ];

const testData = {
    datasets: [
      {
        label: "My Time Series",
        data: rawData
          .filter(d => Number.isFinite(d.ts) && Number.isFinite(d.value))
          .map(d => ({
            x: d.ts * 1000, // convert seconds → ms
            y: d.value
          })),
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.3
      }
    ]
  };

const testOptions = {
    maintainAspectRatio: false,
    responsive: true,
    
    plugins: {
      title: {
        display: true,
        text: "Unix Timestamp Time Series"
      },
      
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "hour" ,// can be 'minute', 'hour', etc.
           // set step size for x-axis ticks
        },
        
                
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        
        min: 0, // set minimum value for y-axis,
        max: 60, // set maximum value for y-axis
        stepSize: 25, // set step size for y-axis ticks
        beginAtZero: true,
        steps: 4

      }
    },
   elements: {
    point: {
      radius: 0 // Set the radius of the points to 0 to hide them
    }
   }
  };

  function buildChartOptionsHorizontal(data, options:ChartOptions):any{
    console.log('inside buildChartOptionsHorizontal with data:',data)
    const axisOptions:AxisOptions = {
        minScalar:0.9,
        maxScalar:1.1
    }
    
    const valueAxis= BuildChartAxis(data, axisOptions)
    const chartOptions = {
        maintainAspectRatio: false,
        responsive: true,
        
        plugins: {
          title: {
            display: true,
            text: 'PlaceHolder Title'
          },
          
        },
        scales: {
          x: {
            type: "time",
            time: {
              unit: "hour" ,// can be 'minute', 'hour', etc.
               // set step size for x-axis ticks
            },
            
            title: {
              display: true,
              text: "Date"
            }
          },
          y: {
            
            min: valueAxis.min, // set minimum value for y-axis,
            max: valueAxis.max, // set maximum value for y-axis
            stepSize: 25, // set step size for y-axis ticks
            beginAtZero: true,
            steps: 4

          }
        },
       elements: {
        point: {
          radius: 0 // Set the radius of the points to 0 to hide them
        }
       }
      };  
      return chartOptions
  }
function Chart(props:ChartProps){
    const {data, options} = props
  
    const lineOptions = buildChartOptionsHorizontal(data, options)
    console.log('line options:',lineOptions)
    console.log('chart options:',options)
   
    return(
       
        <div style={{border:'1px solid #1E2A3B', borderRadius:5, padding:10, margin:10, display:'flex', flexDirection:'column', height:'400px', width:'1280px', backgroundColor:'white'} }>
            { isPopulated(data) &&
            <Line options={lineOptions} data={buildChartData(data)}/>
            }
            
        </div>
    )

}
export default Chart